import { jsx as _jsx } from "react/jsx-runtime";
import { Device } from '@iotv/datamodel-core';
import { DeviceTransactionLabels, DeviceTransactionStatus } from '@iotv/iotv-v3-types';
import { Step, StepLabel, Stepper, Typography } from '@mui/material';
import { timestampToISODateTime } from '../../helpers/format';
import { getNetwork, getNetworkSteps, getSteps } from './steps';
const debug = process.env.REACT_APP_DEBUG && false;
export const TransactionStateSteps = ({ device, currentDeviceTransaction, steps: stepsIn, isSmallView }) => {
    const network = getNetwork(new Device(currentDeviceTransaction?.initialRequest.device ?? device));
    const networkSteps = structuredClone(stepsIn) ?? getNetworkSteps(network);
    const steps = getSteps(networkSteps, currentDeviceTransaction?.status);
    const statusStepIndex = currentDeviceTransaction ? (steps.findIndex((step) => step === currentDeviceTransaction.status) ?? 0) : -1;
    let latest = -Infinity;
    const latestStepIndex = currentDeviceTransaction
        ? currentDeviceTransaction.transactionStages.findLastIndex((s) => {
            const isNewer = latest <= s.timestampsMs;
            if (isNewer)
                latest = s.timestampsMs;
            return isNewer;
        })
        : -1;
    const activeStepIndex = Math.max(statusStepIndex, latestStepIndex);
    return (_jsx(Stepper, { activeStep: activeStepIndex, orientation: isSmallView ? 'vertical' : 'horizontal', sx: isSmallView
            ? {
                '.MuiStepConnector-lineVertical': {
                    display: 'none',
                },
                '.MuiStep-root': {
                    minHeight: 0,
                    padding: 0,
                    margin: 0,
                },
                '.MuiStepLabel-root': {
                    minHeight: 0,
                    padding: 0,
                    margin: 0,
                },
            }
            : undefined, children: steps.map((step, i) => {
            const timestamp = currentDeviceTransaction?.transactionStages.find((s) => s.status === step)?.timestampsMs;
            return (_jsx(Step, { color: step === DeviceTransactionStatus.DOWNLINK_CONFIG_ERROR ? 'primary' : 'secondary', children: _jsx(StepLabel, { sx: { fontSize: 13 }, optional: timestamp && _jsx(Typography, { variant: "caption", children: timestampToISODateTime(timestamp) }), children: step ? DeviceTransactionLabels[step] : `No label for step ${i} of ${JSON.stringify(steps)}` }) }, step));
        }) }));
};
